"use strict";

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}

function _objectWithoutProperties(e, t) {
  var r = {};

  for (var n in e) {
    t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
  }

  return r;
}

function withReveal(e, t) {
  var r = void 0;
  return "function" == typeof e && "string" == typeof e.styledComponentId && (r = "innerRef"), function (n) {
    var o = n.force,
        i = n.mountOnEnter,
        a = n.unmountOnExit,
        p = n.opposite,
        u = n.mirror,
        l = n.wait,
        c = n.onReveal,
        s = n.in,
        f = n.when,
        d = n.spy,
        x = n.collapse,
        v = n.onExited,
        _ = n.enter,
        m = n.exit,
        O = n.appear,
        y = _objectWithoutProperties(n, ["force", "mountOnEnter", "unmountOnExit", "opposite", "mirror", "wait", "onReveal", "in", "when", "spy", "collapse", "onExited", "enter", "exit", "appear"]);

    return _react2.default.createElement(t.type, _extends({
      force: o,
      mountOnEnter: i,
      unmountOnExit: a,
      opposite: p,
      mirror: u,
      wait: l,
      onReveal: c,
      in: s,
      when: f,
      spy: d,
      collapse: x,
      onExited: v,
      enter: _,
      exit: m,
      appear: O
    }, t.props, {
      refProp: r
    }), _react2.default.createElement(e, y));
  };
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var _extends = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];

    for (var n in r) {
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
  }

  return e;
},
    _react = require("react"),
    _react2 = _interopRequireDefault(_react);

exports.default = withReveal, module.exports = exports.default;